import { LuSearch } from "@/Components/Icons/Icons";

export default {
  row1 :[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "dfiaItemImportItemSno",
          label: "Item SNo Part C",
          component: "text-field",
          icon: LuSearch,
          required : true
        },
         {
          name: "dfiaItemType",
          label: "Item type",
          component: "dropdown",
          endIconName: "LuChevronDown",
          options: [
            { label: "Imported", value: "Imported" },
            { label: "Indigenous", value: "Indigenous" }
          ],
        },
      ],
      row2: [
        {
          name: "dfiaItemDescription",
          label: "Description",
          component: "text-field",
        },
      ],
      row3:[
        {
          name: "dfiaItemQuantity",
          label: "Quantity",
          component: "text-field",
          dataType : "int"
        },
        {
          name: "dfiaItemUnit",
          label: "Unit",
          component: "text-field",
          type : "autocomplete",
          endpoint: "getQuantity",
        },
      ]
    },
  },
]
};
